
<mis-multi-select-dropdown
[data]="optionList"
[label]="label"
height=""
[width]="width"
dropdownListHeight=""
[dropdownListWidth]="dropdownListWidth"
dropdownListPosition="Right"
[searchEnabled]="false"
[selectedItems]="selectedItems"
[showSelectedCount]="false"
noDataMessage="No Data"
[hideApplyButton]="true"
[enableSelectAll]="true"
(onChange)="checkValue($event)"
></mis-multi-select-dropdown>
<div class="error-msg" *ngIf="showError()">{{getErrorMessage(formControl)}}</div>
<!-- <div class="dropdown-container" appClickOutside (clickOutside)="clickOutside()" [isActive]="isListShown">
  <button class="trigger" (click)="onTriggerClick($event)" [disabled]="formControl && formControl.disabled"
    [ngClass]="{'error': showError()}" (keydown)="setHighlightedOption($event)">
    <span>{{label}}</span>
    <span *ngIf="selectedOptions && selectedOptions.length" class="selected-number">{{selectedOptions.length}}</span>
    <img class="caret-icon" [src]="isListShown ? 'assets/caret-up.svg' : 'assets/caret-down.svg'">
  </button>
  
  <ul *ngIf="isListShown" class="dropdown-list" (keydown)="setHighlightedOption($event)">
    <li *ngFor="let option of optionList; let optionIndex = index;" class="dropdown-option"
      [ngClass]="{'active-item': optionIndex == activeOption}" type="none">
      <app-checkbox [text]="getOptionLabel(option)" [checkboxValue]="getOptionValue(option)" [checked]="option.selected"
        type="checkmark" (checkboxSelectedCallback)="onOptionSelect(option, $event)"></app-checkbox>
    </li>
  </ul>
  <div class="error-msg" *ngIf="showError()">{{getErrorMessage(formControl)}}</div>
</div> -->
<!-- label="Select" dropdownListHeight=""
  dropdownListWidth="176px" dropdownListPosition="Left" -->